/**
 * linkText.js : libellés du lien de séance (pur, i18n, D247).
 *
 * Portée affichée avec le texte de periodText.js (date et heure dans le
 * fuseau du navigateur, D201) ; codes d'erreur des routes traduits en FR et EN.
 */
import { formatDateLocale } from '../../utils/formatters';
import { formatPeriodInstant } from '../period/periodText';

// Codes des routes propriétaire (POST / GET / DELETE /api/sessions/:id/links).
export const OWNER_ERROR_CODES = Object.freeze([
  'LABEL_INVALID', 'DURATION_INVALID', 'PERIOD_INVALID', 'PERIOD_OUT_OF_RANGE', 'PERIOD_TOO_SHORT',
  'PERIOD_NO_READINGS', 'LINK_LIMIT_REACHED', 'LINK_NOT_FOUND', 'SESSION_NOT_FOUND', 'FORBIDDEN',
  'TOO_MANY_REQUESTS', 'SERVER_ERROR',
]);
// Codes des routes publiques.
export const PUBLIC_ERROR_CODES = Object.freeze([
  'LINK_NOT_FOUND', 'LINK_EXPIRED', 'LINK_REVOKED', 'TOO_MANY_REQUESTS', 'SERVER_ERROR',
]);

export const LINK_DURATIONS = Object.freeze([1, 7, 30]);
export const DEFAULT_LINK_DURATION = 7;
export const LABEL_MAX = 80;

const LONG_DATE = { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' };
export const formatLinkDate = (iso) => formatDateLocale(iso, LONG_DATE);

/** Bornes d'une période en ms epoch : « 24/10/2026 08:00 → 24/10/2026 16:00 ». */
export const periodRangeText = (start, end) => `${formatPeriodInstant(start)} → ${formatPeriodInstant(end)}`;

/** Portée d'un lien de la liste (from / to en ISO, ou null). */
export function linkScopeText(link, t) {
  if (!link?.from || !link?.to) return t('sessionLink.scope.whole');
  return t('sessionLink.scope.period', { range: periodRangeText(new Date(link.from).getTime(), new Date(link.to).getTime()) });
}

/** Message d'erreur d'une route propriétaire. */
export function ownerErrorText(error, t) {
  const code = OWNER_ERROR_CODES.includes(error?.code) ? error.code : 'SERVER_ERROR';
  return t(`sessionLink.error.${code}`, { limit: error?.limit ?? 20 });
}

/** Message d'erreur d'une route publique. */
export function publicErrorText(code, t) {
  return t(`sessionLink.public.error.${PUBLIC_ERROR_CODES.includes(code) ? code : 'SERVER_ERROR'}`);
}
